<style lang="less" scoped></style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">推送日志</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <!-- <div class="query-title-div">启动方式</div> -->
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.operatorId"
                clearable
              >
                <el-option label="联联" value="425010765"></el-option>
                <el-option label="东风启辰" value="717869088"></el-option>
                <el-option label="北京现代" value="MA0081AT4"></el-option>
                <el-option label="山东烟草" value="SDYCOPERATOR"></el-option>
                <el-option label="众巅蓄电" value="ZHONGDIAN"></el-option>
                <el-option label="中欧" value="ZHONGOU"></el-option>
                <el-option label="上海电力" value="549555305"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <!-- <div class="query-title-div">启动方式</div> -->
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pushTypeCode"
                clearable
              >
                <el-option label="推送开始充电" value="01"></el-option>
                <el-option label="推送充电状态" value="02"></el-option>
                <el-option label="推送停止充电" value="03"></el-option>
                <el-option label="推送状态变化" value="04"></el-option>
                <el-option label="推送订单" value="05"></el-option>
                <el-option label="推送充电站信息" value="06"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">桩号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.connectorId"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <!-- <div class="query-title-div">角色状态</div> -->
            <div class="query-inputs-div flex-1">
              <el-date-picker
                v-model="searchTime"
                :picker-options="pickerOptions"
                style="width:340px;"
                type="datetimerange"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="listAddFun()">新 增</button>
                <button class="common-bg-button" @click="listEditFun()">编 辑</button> -->
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels
            }
          "
        ></ZD-table>
        <!-- <el-table :data="tableData" border stripe style="width: 100%">
                    <el-table-column type="index" width="40" align="center">
                    </el-table-column>
                    <el-table-column prop="url" label="url" width="300" align="center"></el-table-column>
                    <el-table-column prop="operatorId" label="operatorId" width="120" align="center"></el-table-column>
                    <el-table-column prop="connectorId" label="桩号" width="300" align="center"></el-table-column>
                    <el-table-column prop="pushData" label="推送参数" width="300" align="center"></el-table-column>
                    <el-table-column prop="requestJson" label="推送参数(加密)" width="300" align="center"></el-table-column>
                    <el-table-column prop="backData" label="返回参数" width="300" align="center"></el-table-column>
                    <el-table-column prop="backDataAes" label="返回参数(加密)" width="300" align="center"></el-table-column>
                    <el-table-column prop="pushTypeCode" label="推送类型" width="300" align="center"></el-table-column>
                    <el-table-column prop="pushTypeName" label="推送类型" width="300" align="center"></el-table-column>
                    <el-table-column prop="createdWhen" label="时间" width="300" align="center"></el-table-column>
                    <el-table-column prop="url" label="url" width="300" align="center"></el-table-column>
                </el-table> -->
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import utils from '../../../utils/utils'
import config from '../../../config/config'
import axios from 'axios'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {},  //页码 与搜索内容
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      searchTime: [],  //选择日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {

    init() {
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this

      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize
      _.queryInfo.sort = '-createdWhen'
      // _.$H.post(_, _.$A.finance.calcpage, _.queryInfo).then(res => {
      //     _.tableData = res.data.data.content || [];
      //     _.pagination.total = res.data.data.totalElements || 0;
      //     _.$U.hideLoading(_);
      // })
      axios
        .post(_.$A.push.page, _.queryInfo, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            authorization: _.$store.state.token,
          },
          timeout: config.httpTimeOut,
        })
        .then((res) => {
          _.tableData = res.data.content || []
          _.pagination.total = res.data.totalElements || 0
          _.$U.hideLoading(_)
          //var str = '{ "name": "cxh", "sex": "man" }'
          //console.log(str.parseJSON())
          // var obj = eval('(' + _.tableData.pushData + ')');
          // console.log(obj)
          // arr.forEach((value , index) => {
          //     value['sex'] = 'men'
          // })
          _.tableData.forEach((item) => {
            if (item.operatorId == '425010765' && item.pushTypeCode == '05') {
              _.tableData.forEach((value, index) => {
                value['totalServiceMoney'] = JSON.parse(
                  item.pushData
                ).OrderInfo.TotalServiceMoney
                value['startChargeSeq'] = JSON.parse(
                  item.pushData
                ).OrderInfo.StartChargeSeq
                value['startTime'] = JSON.parse(
                  item.pushData
                ).OrderInfo.StartTime
                value['totalElecMoney'] = JSON.parse(
                  item.pushData
                ).OrderInfo.TotalElecMoney
                value['endTime'] = JSON.parse(item.pushData).OrderInfo.EndTime
                value['totalMoney'] = JSON.parse(
                  item.pushData
                ).OrderInfo.TotalMoney
                value['orderId'] = ''
                value['elecMoney'] = ''
                value['seviceMoney'] = ''
              })
            } else if (
              item.operatorId == '425010765' &&
              item.pushTypeCode == '02'
            ) {
              _.tableData.forEach((value, index) => {
                value['startChargeSeq'] = JSON.parse(
                  item.pushData
                ).StartChargeSeq
                value['orderId'] = JSON.parse(item.pushData).OrderId
                value['startTime'] = JSON.parse(item.pushData).StartTime
                value['endTime'] = JSON.parse(item.pushData).EndTime
                value['totalMoney'] = JSON.parse(item.pushData).TotalMoney
                value['elecMoney'] = JSON.parse(item.pushData).ElecMoney
                value['seviceMoney'] = JSON.parse(item.pushData).SeviceMoney
                value['totalElecMoney'] = ''
              })
            } else {
              _.tableData.forEach((value, index) => {
                value['seviceMoney'] = ''
                value['startChargeSeq'] = ''
                value['startTime'] = ''
                value['totalMoney'] = ''
                value['totalElecMoney'] = ''
                value['orderId'] = ''
                value['elecMoney'] = ''
                value['endTime'] = ''
              })
            }
          })
        })
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.fromTime = val[0]
        this.queryInfo.toTime = val[1]
      } else {
        delete this.queryInfo.fromTime
        delete this.queryInfo.toTime
      }
    },
    // 页面新增方法
    // listAddFun() {
    //     this.$S.listAddFun(this, pageConfig.tableEditObj);
    // },
    // 页面编辑方法
    // listEditFun() {
    //     this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
    // },
    //重置
    reset() {
      this.pagination.current = 1
      delete this.queryInfo.operatorId
      delete this.queryInfo.pushTypeCode
      delete this.queryInfo.connectorId
      delete this.queryInfo.fromTime
      delete this.queryInfo.toTime
      this.searchTime = []
      this.getListData(this.pagination)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
